import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import Info from '../../../../../components/channel-configuration/info';
import { ChannelBox } from '../../../components/channel/box';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { InputsType } from '../components/inputs-type';
import ReturnBehaviorSelect from '../components/return-behavior-select';
import SwapIn from '../components/swap-in';
import { InfoPageType } from '../types';

type SwitchConfigurationProps = {
  setInfoPage: Dispatch<SetStateAction<InfoPageType>>;
};

const SwitchConfiguration: React.FC<SwitchConfigurationProps> = ({ setInfoPage }) => {
  const { t } = useTranslation('configuration');
  const { channel } = useDevicesAndChannelsContext();

  if (!channel) return null;

  return (
    <>
      <Info title={t('channelTest')} onClick={() => setInfoPage(InfoPageType.CHANNEL)} />
      <ChannelBox channel={channel} isListItem noRedirect />

      <SwapIn channel={channel} setInfoPage={setInfoPage} />

      <InputsType setInfoPage={setInfoPage} />
      <ReturnBehaviorSelect channel={channel} />
    </>
  );
};

export default SwitchConfiguration;
